/**
 * TopBar —— 每頁頂欄：**‹ 返回** ＋ 標題（＋ 右邊 slot）
 * ⚠️ PWA／SPA **冇瀏覽器返回鍵** → app 一定要有自己嘅返回（否則入到去出唔返）。
 */
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TopBar({ title, right }: { title: string; right?: ReactNode }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const goBack = () => {
    // 有上一頁 → 返上一頁；直接入嚟（冇 history）→ 返首頁
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };
  return (
    <header className="topbar">
      <div className="topbar-lead">
        <button type="button" className="backbtn" onClick={goBack} aria-label={t('nav.back')}>‹</button>
        <h1>{title}</h1>
      </div>
      {right}
    </header>
  );
}
